/* ol-b2c-reservation.js — Réservation B2C O'Lenita
   Query cross-section : root reservation + section dates.
   Worker : GET /availability, POST /booking-request (form Phase 3). */

(function () {
  'use strict';

  const root = document.querySelector('[data-ol-b2c-reservation]');
  if (!root) return;

  const datesRoot = document.querySelector('[data-ol-b2c-dates]');

  const cfg = {
    workerUrl: (root.dataset.workerUrl || '').replace(/\/$/, ''),
    monthsDesktop: parseInt((datesRoot && datesRoot.dataset.monthsDesktop) || '2', 10),
    monthsMobile: parseInt((datesRoot && datesRoot.dataset.monthsMobile) || '1', 10),
    paxMin: parseInt(root.dataset.paxMin || '1', 10),
    paxMax: parseInt(root.dataset.paxMax || '20', 10),
    paxDefault: parseInt(root.dataset.paxDefault || '14', 10),
    houseSlug: root.dataset.houseSlug || 'baita',
    houseName: root.dataset.houseName || 'Le Mas Baïta',
    houseCapa: parseInt(root.dataset.houseCapa || '20', 10),
    housePriceEuros: Math.round(parseInt(root.dataset.housePriceCents || '0', 10) / 100),
    minNights: parseInt(root.dataset.minNights || '2', 10),
  };

  let priceVariations = [];
  try {
    priceVariations = JSON.parse(root.dataset.priceVariations || '[]');
  } catch (err) {
    console.warn('[ol-resa] price_variations parse failed', err);
  }

  function computePriceForDate(dateIso) {
    if (cfg.housePriceEuros <= 0) return 0;
    let price = cfg.housePriceEuros;
    for (const v of priceVariations) {
      if (!v || !v.start || !v.end) continue;
      if (dateIso >= v.start && dateIso <= v.end) {
        const val = Number(v.value) || 0;
        const type = (v.type || '').toLowerCase();
        const isPercent = type.includes('pourc') || type.includes('percent') || type.includes('%');
        const isFixed = type.includes('fixe') || type.includes('fixed') || type.includes('€');
        if (isPercent) {
          price = price * (1 + val / 100);
        } else if (isFixed) {
          price = price + val;
        }
      }
    }
    return Math.round(price);
  }

  const mqMobile = window.matchMedia('(max-width: 1023px)');

  const state = {
    pax: cfg.paxDefault,
    checkIn: null,
    checkOut: null,
    busy: [],
    cursor: { year: new Date().getFullYear(), month: new Date().getMonth() },
    monthsToShow: mqMobile.matches ? cfg.monthsMobile : cfg.monthsDesktop,
  };

  mqMobile.addEventListener('change', (e) => {
    state.monthsToShow = e.matches ? cfg.monthsMobile : cfg.monthsDesktop;
    renderCalendar();
  });

  const WEEKDAYS = ['LUN', 'MAR', 'MER', 'JEU', 'VEN', 'SAM', 'DIM'];
  const MONTHS = ['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre'];

  const pad = (n) => String(n).padStart(2, '0');
  const iso = (d) => `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}`;
  const parseISO = (s) => { const [y,m,d] = s.split('-').map(Number); return new Date(y, m-1, d); };
  const addMonths = (y, m, n) => { const d = new Date(y, m + n, 1); return { year: d.getFullYear(), month: d.getMonth() }; };
  const nightsBetween = (a, b) => Math.max(0, Math.round((parseISO(b) - parseISO(a)) / (1000*60*60*24)));
  const humanDate = (s) => { const d = parseISO(s); return `${pad(d.getDate())} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`; };
  const today = () => { const d = new Date(); d.setHours(0,0,0,0); return d; };
  const isBusy = (dateIso) => state.busy.some(b => dateIso >= b.start && dateIso < b.end);

  async function fetchAvailability() {
    if (!cfg.workerUrl || !datesRoot) { renderCalendar(); return; }
    const start = new Date(state.cursor.year, state.cursor.month, 1);
    const end = new Date(state.cursor.year, state.cursor.month + state.monthsToShow + 1, 0);
    const url = `${cfg.workerUrl}/availability?start=${iso(start)}&end=${iso(end)}&house=${cfg.houseSlug}`;
    try {
      const res = await fetch(url);
      const data = await res.json();
      state.busy = (data && data.ok && data.houses && data.houses[cfg.houseSlug] && data.houses[cfg.houseSlug].busy) || [];
    } catch (err) {
      console.warn('[ol-resa] availability fetch failed', err);
      state.busy = [];
    }
    renderCalendar();
  }

  function renderCalendar() {
    if (!datesRoot) return;
    const calRoot = datesRoot.querySelector('[data-calendar]');
    if (!calRoot) return;
    calRoot.innerHTML = '';
    for (let i = 0; i < state.monthsToShow; i++) {
      const { year, month } = addMonths(state.cursor.year, state.cursor.month, i);
      calRoot.appendChild(buildMonth(year, month));
    }
  }

  function buildMonth(year, month) {
    const wrap = document.createElement('div');
    wrap.className = 'ol-b2c-reservation__month';

    const title = document.createElement('p');
    title.className = 'ol-b2c-reservation__month-title';
    title.textContent = `${MONTHS[month]} ${year}`;
    wrap.appendChild(title);

    const grid = document.createElement('div');
    grid.className = 'ol-b2c-reservation__month-grid';

    WEEKDAYS.forEach(d => {
      const el = document.createElement('span');
      el.className = 'ol-b2c-reservation__weekday';
      el.textContent = d;
      grid.appendChild(el);
    });

    const first = new Date(year, month, 1);
    const startOffset = (first.getDay() + 6) % 7;
    for (let i = 0; i < startOffset; i++) {
      const empty = document.createElement('span');
      empty.className = 'ol-b2c-reservation__day ol-b2c-reservation__day--empty';
      grid.appendChild(empty);
    }

    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const tIso = iso(today());
    for (let day = 1; day <= daysInMonth; day++) {
      const d = new Date(year, month, day);
      const dIso = iso(d);
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ol-b2c-reservation__day';
      btn.dataset.iso = dIso;

      const numSpan = document.createElement('span');
      numSpan.className = 'ol-b2c-reservation__day-num';
      numSpan.textContent = day;
      btn.appendChild(numSpan);

      if (cfg.housePriceEuros > 0) {
        const priceSpan = document.createElement('span');
        priceSpan.className = 'ol-b2c-reservation__day-price';
        priceSpan.textContent = `${computePriceForDate(dIso)}€`;
        btn.appendChild(priceSpan);
      }

      if (dIso === tIso) btn.classList.add('ol-b2c-reservation__day--today');
      if (dIso < tIso) {
        btn.classList.add('ol-b2c-reservation__day--past');
        btn.disabled = true;
      } else if (isBusy(dIso)) {
        btn.classList.add('ol-b2c-reservation__day--busy');
        btn.disabled = true;
      } else {
        btn.classList.add('ol-b2c-reservation__day--available');
      }

      if (state.checkIn && dIso === state.checkIn) btn.classList.add('ol-b2c-reservation__day--selected');
      if (state.checkOut && dIso === state.checkOut) btn.classList.add('ol-b2c-reservation__day--selected');
      if (state.checkIn && state.checkOut && dIso > state.checkIn && dIso < state.checkOut) {
        btn.classList.add('ol-b2c-reservation__day--in-range');
      }

      if (!btn.disabled) btn.addEventListener('click', () => onDayClick(dIso));
      grid.appendChild(btn);
    }
    wrap.appendChild(grid);
    return wrap;
  }

  function bindTogglePrices() {
    if (!datesRoot) return;
    const toggle = datesRoot.querySelector('[data-toggle-prices]');
    const card = datesRoot.querySelector('[data-calendar-card]');
    if (!toggle || !card) return;
    toggle.addEventListener('change', () => {
      card.classList.toggle('show-prices', toggle.checked);
    });
  }

  function onDayClick(dIso) {
    if (!state.checkIn || (state.checkIn && state.checkOut)) {
      state.checkIn = dIso;
      state.checkOut = null;
    } else if (dIso <= state.checkIn) {
      state.checkIn = dIso;
      state.checkOut = null;
    } else {
      const nights = nightsBetween(state.checkIn, dIso);
      if (nights < cfg.minNights) {
        // Séjour trop court : reset check-in sur ce jour
        state.checkIn = dIso;
        state.checkOut = null;
      } else {
        let hasBusyBetween = false;
        const from = parseISO(state.checkIn);
        const to = parseISO(dIso);
        for (let d = new Date(from); d < to; d.setDate(d.getDate() + 1)) {
          if (isBusy(iso(d))) { hasBusyBetween = true; break; }
        }
        if (hasBusyBetween) {
          state.checkIn = dIso;
          state.checkOut = null;
        } else {
          state.checkOut = dIso;
        }
      }
    }
    renderCalendar();
    updateRecap();
  }

  function bindNav() {
    if (!datesRoot) return;
    const prev = datesRoot.querySelector('[data-cal-prev]');
    const next = datesRoot.querySelector('[data-cal-next]');
    if (prev) prev.addEventListener('click', () => {
      const { year, month } = addMonths(state.cursor.year, state.cursor.month, -1);
      state.cursor = { year, month };
      fetchAvailability();
    });
    if (next) next.addEventListener('click', () => {
      const { year, month } = addMonths(state.cursor.year, state.cursor.month, 1);
      state.cursor = { year, month };
      fetchAvailability();
    });
  }

  function bindPax() {
    const decr = root.querySelector('[data-pax-decr]');
    const incr = root.querySelector('[data-pax-incr]');
    const val = root.querySelector('[data-pax-value]');
    const plusWrap = root.querySelector('[data-pax-plus-wrap]');
    const syncBtns = () => {
      if (decr) decr.disabled = state.pax <= cfg.paxMin;
      if (incr) incr.disabled = state.pax >= cfg.houseCapa;
      if (plusWrap) plusWrap.classList.toggle('is-at-max', state.pax >= cfg.houseCapa);
    };
    if (decr) decr.addEventListener('click', () => {
      if (state.pax > cfg.paxMin) { state.pax--; if (val) val.textContent = state.pax; syncBtns(); }
    });
    if (incr) incr.addEventListener('click', () => {
      if (state.pax < cfg.houseCapa) { state.pax++; if (val) val.textContent = state.pax; syncBtns(); }
    });
    syncBtns();
  }

  function bindCheckAvailability() {
    const btn = root.querySelector('[data-check-availability]');
    const target = datesRoot;
    if (btn && target) {
      btn.addEventListener('click', () => {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  function bindActions() {
    if (!datesRoot) return;
    const reset = datesRoot.querySelector('[data-recap-reset]');
    const cont = datesRoot.querySelector('[data-recap-continue]');
    if (reset) reset.addEventListener('click', () => {
      state.checkIn = null; state.checkOut = null;
      renderCalendar(); updateRecap();
    });
    if (cont) cont.addEventListener('click', () => {
      const next = document.querySelector('[data-ol-b2c-services]') || document.querySelector('[data-ol-b2c-form]');
      if (next) next.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function updateRecap() {
    if (!datesRoot) return;
    const cont = datesRoot.querySelector('[data-recap-continue]');
    if (cont) cont.disabled = !(state.checkIn && state.checkOut);
  }

  // === Galerie : swap image principale + navigation flèches ===
  function bindGallery() {
    const heroPhoto = root.querySelector('[data-hero-photo]');
    const thumbs = Array.from(root.querySelectorAll('[data-thumb]'));
    const prev = root.querySelector('[data-hero-prev]');
    const next = root.querySelector('[data-hero-next]');
    if (!heroPhoto || thumbs.length === 0) return;

    let idx = 0;

    function activate(newIdx) {
      idx = ((newIdx % thumbs.length) + thumbs.length) % thumbs.length;
      const t = thumbs[idx];
      const src = t.dataset.heroSrc;
      const srcset = t.dataset.heroSrcset;
      if (src) heroPhoto.src = src;
      if (srcset) heroPhoto.srcset = srcset;
      thumbs.forEach((el, i) => el.classList.toggle('ol-b2c-reservation__thumb--active', i === idx));
    }

    thumbs.forEach((t, i) => t.addEventListener('click', () => activate(i)));
    if (prev) prev.addEventListener('click', () => activate(idx - 1));
    if (next) next.addEventListener('click', () => activate(idx + 1));
  }

  function init() {
    bindPax();
    bindNav();
    bindCheckAvailability();
    bindActions();
    bindGallery();
    bindTogglePrices();
    updateRecap();
    if (datesRoot) fetchAvailability();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
